<template>
  <SourcePageDesktop v-if="$tvaMq !== 'mobile' && $tvaMq !== 'tablet'" />
  <SourcePageMobile v-else />
</template>

<script>
import SourcePageDesktop from "./SourcePageDesktop.vue";
import SourcePageMobile from "../components/mobile/SourcePageMobile.vue";

export default {
  name: "SourcePage",
  components: {
    SourcePageDesktop,
    SourcePageMobile,
  },
};
</script>

<style lang="scss" scoped></style>
